var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ui-text-field',{attrs:{"label":_vm.$t('name'),"value":_vm.name},on:{"input":function($event){return _vm.$emit('update:name', $event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }